<script>
	export let lang, alturl, data, width, preferredStore, authenticated, label_products, links, links_account, isHF, mountpoint

	const en = lang == 'en'
	
	// new
	// const HBCategories = ["7219", "1525535413182"]
	// const locationType = preferredStore.attributes ? preferredStore.attributes.find(att => att.fullyQualifiedName=="tenant~storetype").values[0] || "Home Hardware" : "Home Hardware"
	// end new

	let path = []

	$: L1obj = data
	// $: L1obj = locationType=="Home Hardware" ? filterOutHBCategories(data) : data
	$: L2obj = path.length<1 || L1obj.map(		(item) => { return item.i == path[0] ? item : false } ).filter(Boolean)[0]
	$: L3obj = path.length<2 || L2obj.c.map(	(item) => { return item.i == path[1] ? item : false } ).filter(Boolean)[0]

	$: isMobile = width < 800
	$: if (isMobile||!isMobile) path = [] // when `isMobile` changes, reset the nav
	$: if (path) mountpoint.dataset.navLevel = path.length >= 1 ? 1 : 0 // when `path` changes, update mountpoint[data-nav-level]
	

	

	const close = () => {
		mountpoint.classList.remove("active")
		path = []
	}

	const handleEsc = (event) => {
		// capture escape key to close nav
		if (event.key === 'Escape') {
			close()
		}
	}


	const sortByChildren = (obj) => {
		return obj
		// return obj.sort((a, b) => a.c.length < b.c.length)
	}

	const switchLang = (e) => {
		// set cookie with opposite lang
		let targetLang = en ? "fr" : "en"
		let expiryDate = new Date()
		expiryDate.setYear(expiryDate.getFullYear() + 1)
		document.cookie = `hhLanguage=${targetLang};expires=${expiryDate};path=/;Secure;SameSite=None`
		// if is a category page, remove the category slug
		let targetURL = e.target.href
		if (targetURL.includes('/c/')) {
			targetURL = targetURL.replace(/\/(en|fr)\/(.*)\/c\/([0-9]*)/i, '/$1/c/$3')
		}
		window.location.href = targetURL;
	}

	// new
	// const filterOutHBCategories = (categories) => {
	// 	return categories.map((category) => {
	// 		if (HBCategories.includes(category.i)) return false
	// 		if (category.c && category.c.length) category.c = filterOutHBCategories(category.c)
	// 		return category
	// 	}).filter(Boolean)
	// }
	// end new

</script>
<svelte:window bind:innerWidth={width} on:keydown={handleEsc} />




<div>
	<header>
		<a href="/">
			{#if !isHF}
			<img src="https://homehardware.sirv.com/resources/images/hh-logo-outline.svg" alt="Home Hardware" width="50" height="50" />
			<!-- <img src="./hh-logo-outline.svg" alt="Home Hardware" width="50" height="50" /> -->
			{:else}
			<img src="https://homehardware.sirv.com/resources/images/en-hfurniture.png" alt="Home Furniture" />
			<!-- <img src="./en-hfurniture.png" alt="Home Furniture" /> -->
			{/if}
		</a>
		<button on:click|preventDefault={close}>{en ? "close" : "fermé"}</button>
	</header>
	
	<ul>
		<li>
			{label_products}
			<ul>
			{#each L1obj as L1}
				{#if L1.c && L1.c.length}
					<li><a href={`/${lang}/${L1.s}/c/${L1.i}`} on:click|preventDefault={() => path=[L1.i] } class={L1.i==path[0] ? "active" : null}>{L1.n}</a></li>
				{:else}
					<li><a href={`/${lang}/${L1.s}/c/${L1.i}`}>{L1.n}</a></li>
				{/if}
			{/each}
			</ul>
		</li>
		{#each links as link }
			<li><a href="{link.href}">{link.innerText}</a></li>
		{/each}
	</ul>

	<ul data-account>
		{#each links_account as link }
			<li>
				<a href="{link.href}">
					<i class="fas {link.href.includes('/login')||link.href.includes('/myaccount') ? "fa-user-circle" : "fa-pen"}"></i>
					{link.innerText}
				</a>
			</li>
		{/each}
	</ul>

	<ul data-secondary>
		<!--<li><a href="/user/order-status">{en ? "Order Status" : "État de la commande"}</a></li>-->
		{#if en}
			<li><a target="_blank" rel="noopener" href="https://www.homefurniture.ca/">Home Furniture</a></li>
			<li><a target="_blank" rel="noopener" href="http://beaverhomesandcottages.ca">Beaver Homes &amp; Cottages</a></li>
		{/if}
		<li><a href="/{lang}/{authenticated ? "" : "login-"}shopping-list">{en ? "My List" : "Ma liste"}</a></li>
		<li><a href="/{lang}/store-locator">{en ? "Select My Store" : "Sélectionnez ma Magasin"}</a></li>
		{#if !isHF}
			<li><a href="{alturl}" data-lang on:click|preventDefault={ switchLang }>{en ? "Français" : "English"}</a></li>
		{/if}
	</ul>
	


	

</div>

{#if isMobile}


	<div>
	{#if L2obj.c && L2obj.c.length }
		<header>
			<h3><a href={`/${lang}/${L2obj.s}/c/${L2obj.i}`}>{en ? "Shop all" : "Tout magasiner"} {L2obj.n}</a></h3>
			<button on:click={() => path=[] }>{en ? "back" : "précédent"}</button>
		</header>
		<ul data-mobile-nav-depth="2">
		{#each L2obj.c as L2}
			{#if L2.i==path[1] && L2.c.length && L3obj.c && L3obj.c.length }
				<li>
					<a href={`/${lang}/${L2.s}/c/${L2.i}`} on:click|preventDefault={() => path=[path[0]] } class={L2.i==path[1] ? "active" : null}>{L2.n} <span class="accordian">×</span></a>
					<ul data-mobile-nav-depth="3">
						{#each L3obj.c as L3}
						<li><a href={`/${lang}/${L3.s}/c/${L3.i}`}>{L3.n}</a></li> 
						{/each}
						<li><a href={`/${lang}/${L2.s}/c/${L2.i}`} class="more">{en ? "Shop all" : "Tout magasiner"} {L2.n}</a></li>
					</ul>
				</li> 
			{:else if L2.c && L2.c.length}
				<li><a href={`/${lang}/${L2.s}/c/${L2.i}`} on:click|preventDefault={() => path=[path[0], L2.i] } class={L2.i==path[1] ? "active" : null}>{L2.n} <span class="accordian">+</span></a></li> 
			{:else}
				<li><a href={`/${lang}/${L2.s}/c/${L2.i}`}>{L2.n}</a></li> 
			{/if}
		{/each}
		</ul>
	{/if}
	</div>

	<!-- <div>
	{#if L3obj.c?.length }
		<header>
			<h3><a href={`/${lang}/${L3obj.s}/c/${L3obj.i}`}>{en ? "Shop all" : "Tout magasiner"} {L3obj.n}</a></h3>
			<button on:click|preventDefault={() => path=[path[0]] }>{en ? "back" : "précédent"}</button> 
		</header>
		<ul data-mobile-nav-depth="3">
			{#each L3obj.c as L3}
			<li><a href={`/${lang}/${L3.s}/c/${L3.i}`}>{L3.n}</a></li> 
			{/each}
		</ul>
	{/if}
	</div> -->

	<!--
	<div>
	{#if L2obj.c?.length }
		<header>
			<h3><a href={`/${lang}/${L2obj.s}/c/${L2obj.i}`}>{en ? "Shop all" : "Tout magasiner"} {L2obj.n}</a></h3>
			<button on:click={() => path=[] }>{en ? "back" : "précédent"}</button>
		</header>
		<ul data-mobile-nav-depth="2">
		{#each L2obj.c as L2}
			{#if L2.c?.length}
				<li><a href={`/${lang}/${L2.s}/c/${L2.i}`} on:click|preventDefault={() => path=[path[0], L2.i] } class={L2.i==path[1] ? "active" : null}>{L2.n}</a></li> 
			{:else}
				<li><a href={`/${lang}/${L2.s}/c/${L2.i}`}>{L2.n}</a></li> 
			{/if}
		{/each}
		</ul>
	{/if}
	</div>

	<div>
	{#if L3obj.c?.length }
		<header>
			<h3><a href={`/${lang}/${L3obj.s}/c/${L3obj.i}`}>{en ? "Shop all" : "Tout magasiner"} {L3obj.n}</a></h3>
			<button on:click|preventDefault={() => path=[path[0]] }>{en ? "back" : "précédent"}</button> 
		</header>
		<ul data-mobile-nav-depth="3">
			{#each L3obj.c as L3}
			<li><a href={`/${lang}/${L3.s}/c/${L3.i}`}>{L3.n}</a></li> 
			{/each}
		</ul>
	{/if}
	</div>
	-->


{:else}

	<div>
		{#key L2obj}
		{#if L2obj.c && L2obj.c.length }
		<header>
			<h3><a href={`/${lang}/${L2obj.s}/c/${L2obj.i}`}>{en ? "Shop all" : "Tout magasiner"} {L2obj.n}</a></h3>
			<button on:click={() => path=[] }>{en ? "back" : "précédent"}</button>
		</header>
		
		<ul>
		{#each sortByChildren(L2obj.c) as L2}
			{#if L2.c && L2.c.length}
				<li>
					<a href={`/${lang}/${L2.s}/c/${L2.i}`}>{L2.n}</a>
					<ul>
						{#each L2.c.slice(0,5) as L3}
						<li><a href={`/${lang}/${L3.s}/c/${L3.i}`}>{L3.n}</a></li> 
						{/each}
						{#if L2.c.length > 5}
						<li><a href={`/${lang}/${L2.s}/c/${L2.i}`} class="more">{en ? "More Categories" : "Plus de catégories"}<!-- <i class="fas fa-plus-circle"></i>--></a></li>
						{/if}
					</ul>
				</li>
			{:else}
				<li><a href={`/${lang}/${L2.s}/c/${L2.i}`}>{L2.n}</a></li> 
			{/if}
		{/each}
		</ul>
		{/if}
		{/key}
	</div>



	<button on:click|preventDefault={close}>{en ? "close" : "fermé"}</button>

{/if}